import {
  BarGraph,
  Calendar,
  CheckCircleLine,
  FileFilled,
  Home,
  Inbox,
  Megaphone,
  People,
  Person,
  Receipt,
  Rocket,
  Settings,
  Sparkles,
} from '@factorialco/f0-react/icons/app'

import { buildUrl } from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import type { SidebarManifest } from './types'

export const sidebarManifest: SidebarManifest = (navigation) => {
  return [
    // Root group
    {
      identifier: 'get_started',
      name: i18n.t('growth.get_started.sidebar'),
      factorialOneIcon: Rocket,
      path: navigation.getStarted.fullPath(),
      group: 'root',
      priority: 'highest',
    },
    {
      identifier: 'dashboard',
      name: i18n.t('sidebar.dashboard'),
      factorialOneIcon: Home,
      path: navigation.dashboard.fullPath(),
      group: 'root',
      module: 'dashboard',
      priority: 'highest',
    },
    {
      identifier: 'inbox',
      name: i18n.t('sidebar.inbox'),
      factorialOneIcon: Inbox,
      path: navigation.inbox.fullPath(),
      group: 'root',
      module: 'notifications',
      priority: 'high',
    },
    {
      identifier: 'calendar',
      name: i18n.t('sidebar.calendar'),
      factorialOneIcon: Calendar,
      path: navigation.calendar.fullPath(),
      group: 'root',
      module: 'calendar',
      priority: 'medium',
    },
    {
      identifier: 'discover',
      name: i18n.t('sidebar.product_updates.discover'),
      factorialOneIcon: Megaphone,
      path: navigation.discover.fullPath(),
      group: 'root',
      module: 'discover',
      priority: 'low',
    },
    // Personal group
    {
      identifier: 'profile',
      name: i18n.t('sidebar.your_profile'),
      factorialOneIcon: Person,
      path: navigation.profile.fullPath(),
      group: 'personal',
      module: 'profile',
      priority: 'highest',
    },
    {
      identifier: 'tasks',
      name: i18n.t('tasks.header'),
      factorialOneIcon: CheckCircleLine,
      path: navigation.tasks.fullPath(),
      group: 'personal',
      module: 'tasks',
      priority: 'medium',
    },
    // Company / General group
    {
      identifier: 'organization',
      name: i18n.t('sidebar.team'),
      factorialOneIcon: People,
      path: navigation.employees.fullPath(),
      group: 'company',
      module: 'employees',
      priority: 'highest',
    },
    // TODO: Re-enable when overview page is ready
    // {
    //   identifier: 'employee_lifecycle_overview',
    //   name: i18n.t('sidebar.employee_lifecycle_overview'),
    //   factorialOneIcon: Home,
    //   path: navigation.employeeLifecycle.fullPath(),
    //   group: 'employee_lifecycle',
    //   module: 'employee_lifecycle',
    //   priority: 'highest',
    // },
    {
      identifier: 'employee_lifecycle_workflows',
      name: i18n.t('sidebar.employee_lifecycle_workflows'),
      factorialOneIcon: Rocket,
      path: navigation.employeeLifecycle.workflows.onboarding.fullPath(),
      group: 'employee_lifecycle',
      module: 'employee_lifecycle',
      priority: 'high',
    },
    // More group
    {
      identifier: 'analytics',
      name: i18n.t('sidebar.analytics'),
      factorialOneIcon: BarGraph,
      path: navigation.analytics.fullPath(),
      group: 'more',
      module: 'analytics',
      priority: 'medium',
    },
    {
      identifier: 'ai_reports',
      name: i18n.t('sidebar.ai_reports'),
      factorialOneIcon: BarGraph,
      path: navigation.aiReports.fullPath(),
      group: 'more',
      module: 'ai_reports',
      priority: 'medium',
    },
    {
      identifier: 'settings',
      name: i18n.t('common.settings'),
      factorialOneIcon: Settings,
      path: navigation.settings.fullPath(),
      group: 'more',
      priority: 'lowest',
    },
    {
      identifier: 'billing',
      name: i18n.t('sidebar.billing'),
      factorialOneIcon: Receipt,
      path: buildUrl('/customer-portal?v2'),
      group: 'more',
      module: 'billing',
      priority: 'medium',
    },
    {
      identifier: 'employee_lifecycle_onboarding',
      name: i18n.t('sidebar.onboarding'),
      factorialOneIcon: Sparkles,
      path: navigation.employeeLifecycle.smartOnboarding.fullPath(),
      group: 'employee_lifecycle',
      module: 'employee_lifecycle',
      priority: 'medium',
    },
    {
      identifier: 'handbook_pages',
      name: i18n.t('sidebar.policies'),
      factorialOneIcon: FileFilled,
      path: navigation.pages.fullPath(),
      group: 'company',
      module: 'handbook_pages',
      priority: 'lowest',
    },
  ]
}
